export { default } from "./ServiceTile";
export type { ServiceTileProps } from "./ServiceTile";
